import type { BranchListQuery } from '@/api/handlers/resources/branches/requests';

/**
 * Centralised TanStack Query keys for the Branches resource. Sharing the keys
 * here keeps mutations and queries from drifting out of step when one is
 * invalidated and the other is read.
 *
 * `details()` is the prefix that covers every paginated page; `detailsPage`
 * adds the query params so each page/search is its own cache entry. Write
 * mutations invalidate the `details()` prefix so all cached pages refetch.
 */
export const BranchQueryKeys = {
    all: ['branches'] as const,
    list: () => [...BranchQueryKeys.all, 'list'] as const,
    details: () => [...BranchQueryKeys.all, 'details'] as const,
    detailsPage: (query: BranchListQuery) =>
        [...BranchQueryKeys.details(), query] as const,
    apiToken: (id: string) =>
        [...BranchQueryKeys.all, 'api-token', id] as const,
};
